<div class="clinical-flucelvax-second">
  @if (thirdnode | async; as item) {
    <div class="product_efficacy-header2">{{item.headLine}}</div>
  }
  @if (thirdnode | async; as item) {
    <div class="product_efficacy-text" [innerHTML]="item.content"></div>
  }
  @if (selectedTabIndex !== undefined) {
    <div class="product_efficacy-header3">
      <p [innerHTML]="mergedObject2[selectedTabIndex]?.h3content"></p>
    </div>
  }
  @if (selectedTabIndex !== undefined) {
    <div class="product_efficacy-text" [innerHTML]="mergedObject2[selectedTabIndex]?.content"></div>
  }


  <div class="product_efficacy-tabContainer" id="product_efficacy-tabContainer2">
    <div class="panel with-nav-tabs panel-primary">
      <div class="panel-heading">
        <mat-tab-group (selectedTabChange)="onTabChange($event)" mat-stretch-tabs="false" mat-align-tabs="start"
          animationDuration="0ms">
          @for (item2 of mergedObject2;  let i= $index; track item2) {
            <div>
              <mat-tab label="{{ item2.headline }}">
                <div class="wrapper" [ngClass]="{'first-tab-wrapper': i === 0,'second-tab-wrapper': i === 1}">
                  <div class="panel_details-anchor" id="panel_details-anchor3" [ngClass]="{'study_Class': i === 1, 'study_Class1': i===0}">
                    <div class="study_Button">
                      <div class="panel_details-button"
                        (click)="toggleStudy(i)"
                        [innerHTML]="item2.h2content">
                      </div>
                    </div>
                    <div class="panel_details-studyText d-xs-none d-sm-none d-none" id="panel_details-studyText1">Study 5<sup>*</sup></div>
                    <div class="panel_details-studyText d-xs-none d-sm-none d-none" id="panel_details-studyText2">Study 6<sup>†<sup></sup></sup></div>
                    <div class="d-lg-none firsttab padding-T10">
                      <!--study 1-->
                      <div class="panel-group product_efficacy-studyGroup" id="product_efficacy-stugyGroup1">
                        <div class="panel panel-default">
                          <div class="panel-heading">
                            <h4 class="panel-title">
                              <a href="#" (click)="toggleCollapse($event, 'study1')">
                                Study 1<sup>*</sup>
                                <i class="fa fa-fw pull-right fas" [ngClass]="{'fa-angle-down': !isCollapsed['study1'], 'fa-angle-up': isCollapsed['study1']}"></i>
                              </a>
                            </h4>
                          </div>
                          <div id="product_efficacy-study1">
                            @if (isCollapsed['study1']) {
                              <div class="panel-body" >
                                @if (item2.media) {
                                  <div class="simple-banner banner__component--responsive ">
                                    <img [src]="getMobileImage(item2.media)" [alt]="item2.media.mobile.altText">
                                  </div>
                                }
                                <div>
                                  <img class="secondimg" src="../../../app/../assets/images/24mo-safety-mobile.webp">
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                      <!--study 2-->
                      <div class="panel-group product_efficacy-studyGroup" id="product_efficacy-stugyGroup2">
                        <div class="panel panel-default">
                          <div class="panel-heading">
                            <h4 class="panel-title">
                              <a href="#" (click)="toggleCollapse($event, 'study2')">
                                Study 2<sup>†</sup>
                                <i class="fa fa-fw pull-right fas" [ngClass]="{'fa-angle-down': !isCollapsed['study2'], 'fa-angle-up': isCollapsed['study2']}"></i>
                              </a>
                            </h4>
                          </div>
                          <div id="product_efficacy-study2">
                            @if (isCollapsed['study2']) {
                              <div class="panel-body">
                                <div>
                                  <img class="firstimg" src="../../../app/../assets/images/4yr-safety-mobile.webp">
                                </div>
                                <div>
                                  <img class="secondimg" src="../../../app/../assets/images/9yr-safety-mobile.webp">
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="d-lg-none padding-T10 secondtab">
                      <!--study 5-->
                      <div class="panel-group product_efficacy-studyGroup" id="product_efficacy-stugyGroup3">
                        <div class="panel panel-default">
                          <div class="panel-heading">
                            <h4 class="panel-title">
                              <a href="#" (click)="toggleCollapse($event, 'study5')">
                                Study 5<sup>*</sup>
                                <i class="fa fa-fw pull-right fas" [ngClass]="{'fa-angle-down': !isCollapsed['study5'], 'fa-angle-up': isCollapsed['study5']}"></i>
                              </a>
                            </h4>
                          </div>
                          <div id="product_efficacy-study3">
                            @if (isCollapsed['study5']) {
                              <div class="panel-body">
                                @if (item2.media) {
                                  <div class="simple-banner banner__component--responsive ">
                                    <img [src]="getMobileImage(item2.media)" [alt]="item2.media.mobile.altText">
                                  </div>
                                }
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                      <!--study 6-->
                      <div class="panel-group product_efficacy-studyGroup" id="product_efficacy-stugyGroup6">
                        <div class="panel panel-default">
                          <div class="panel-heading">
                            <h4 class="panel-title">
                              <a href="#" (click)="toggleCollapse($event, 'study6')">
                                Study 6<sup>†</sup>
                                <i class="fa fa-fw pull-right fas" [ngClass]="{'fa-angle-down': !isCollapsed['study6'], 'fa-angle-up': isCollapsed['study6']}"></i>
                              </a>
                            </h4>
                          </div>
                          <div id="product_efficacy-study6">
                            @if (isCollapsed['study6']) {
                              <div class="panel-body">
                                <div>
                                  <img class="firstimg" src="../../../app/../assets/images/study6-1-mobile.webp">
                                </div>
                                <div>
                                  <img class="secondimg" src="../../../app/../assets/images/study6-2-mobile.webp">
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="panel_body-modal modal" id="adult_abandonedPop">
                  <div class="modal-body panel_modalbody1">
                    <div class="knowledgeHub_abandonedPopClose" (click)="closeModal()"><span>X</span></div>
                    <div class="knowledgeHub_abandonedPopText panel_body-modalContent1">{{ mergedObject2[selectedTabIndex]?.content}}</div>
                  </div>
                </div> -->
              </div>
              <div class="panel_body-Image col-xs-12 desktopimage" [ngClass]="{'first-tab-image': i === 0,'second-tab-image': i === 1}">
                <!-- <div class="simple-banner banner__component--responsive d-md-block d-lg-block d-none d-sm-none">
                <img class="js-responsive-image" [src]="getImage1(item2.media)" [attr.alt]="item2.media?.altText">
              </div>
              <div class="simple-banner banner__component--responsive-mobile d-none d-sm-block d-md-none d-lg-none d-xl-none">
                <img class="js-responsive-image" [src]="getImage1(item2.media)" [attr.alt]="item2.media?.altText">
              </div> -->
              @if (item2.media) {
                <div class="simple-banner banner__component--responsive ">
                  <cx-media [container]="item2.media"></cx-media>
                </div>
              }
            </div>
            <div class="panel_body-disclaimer col-xs-12" [ngClass]="{'first-tab-disclaimer': i === 0,'second-tab-disclaimer': i === 1}" [innerHTML]="item2.bottomParaContent"></div>
            <div class="pop-body " [ngClass]="{'active': study[i] === true,'first-tab-pop': i === 0,'second-tab-pop': i === 1}">
              <div class="pop pop_Body_Text" [ngClass]="study[i] == true ? 'active' : ' '">
                <div class="knowledgeHub_abandonedPopClose" (click) = toggleStudy(i)><span>X</span></div>
                <div class="knowledgeHub_abandonedPopText panel_body-modalContent1"[innerHTML]="item2.largeparagraphcontent"></div>
              </div>
            </div>
          </mat-tab>
        </div>
      }
    </mat-tab-group>

  </div>
</div>
</div>
</div>

